export const MONTH_KEYS = [
  '2026/10',
  '2026/11',
  '2026/12',
  '2027/01',
  '2027/02',
  '2027/03',
  '2027/04',
  '2027/05',
  '2027/06',
  '2027/07',
  '2027/08',
  '2027/09',
] as const;
export const MONTH_COUNT = MONTH_KEYS.length;
export const SCHEDULE_SLOTS = 36;

export const GROUP_KEYS = ['sen', 'mu', 'ki', 'dc', 'mg'] as const;
export const TASK_GROUP_KEYS = ['sen', 'mu', 'ki'] as const;
export const SETTING_GROUP_KEYS = ['hq', 'sen', 'mu', 'ki'] as const;
export const DEST_KEYS = ['G', 'A', 'B', 'C'] as const;
export const SEGMENT_KEYS = ['base', 'ext', 'grow'] as const;
export const STAGE_IDS = [1, 2, 3, 4, 5] as const;
export const STANDARDIZATION_KEYS = ['共通', '工種別'] as const;
export const LOAD_BAND_KEYS = ['free', 'light', 'fit', 'over', 'heavy'] as const;

export const DEPT_WORK_ID = '部門';
export const TENTATIVE_STATUSES = ['引合', '受注予定'] as const;
export const HOURS_PER_NINKU = 160;

export const ROLE_AGENT = '現場代理人';
export const ROLE_MANAGER = '施工管理';
export const ROLE_SUPPORT = '作業管理・支援';
export const ROLE_COVER = '応援（代理人兼務）';
export const ROLE_DEPT = '管理・支援';

/** 管理機能の権限(モジュール単位)。 */
export const PERMISSIONS = [
  'tasks:write',
  'schedule:write',
  'cases:write',
  'staff:write',
  'allocations:write',
  'accounts:write',
] as const;
